import { exportFinancialData } from 'common/api/creditApplications';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import { SET_IS_DOWNLOADING } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (proposalId) => (dispatch) => {
    dispatch(creditFileActions[SET_IS_DOWNLOADING](true));

    exportFinancialData(proposalId)
        .then((response) => {
            dispatch(creditFileActions[SET_IS_DOWNLOADING](false));
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Corrida_financiera.csv`);
            document.body.appendChild(link);
            link.click();
            dispatch(creditFileActions[SET_IS_DOWNLOADING](false));
        })
        .catch((error) => {
            dispatch(creditFileActions[SET_IS_DOWNLOADING](false));
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
